export default __webpack_public_path__ + "trello-website-logo.png";